import { useState } from 'react';
import api from 'api';
import axios from 'axios';
import { useDispatch } from 'hooks';
import { Button } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';

import type { DropdownButtonInterface } from 'components/common/dropdown/DropdownButton';

interface Props extends DropdownButtonInterface {
  external?: boolean;
  filename: string;
  isDropdown?: boolean;
  packet?: any;
  url: string;
}

const ApiDownloadButton = ({
  external,
  filename,
  isDropdown,
  packet,
  url,
  ...props
}: Props) => {
  const { dispatch } = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (ev) => {
    if (ev) ev.stopPropagation();

    try {
      setIsLoading(true);

      let response;
      if (external) {
        response = !packet
          ? await axios.get(url, { responseType: 'blob' })
          : await axios.post(url, packet, { responseType: 'blob' });
      } else {
        response = !packet
          ? await api.get(url, { responseType: 'blob' })
          : await api.post(url, packet, { responseType: 'blob' });
      }

      const blob = new Blob([response.data]);

      // @ts-ignore
      if (window.navigator.msSaveBlob) {
        // download file in ie
        // @ts-ignore
        window.navigator.msSaveBlob(blob, filename);
      } else {
        // download file by simulating a link click
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      setIsLoading(false);

      // click outside dropdown to close it
      if (isDropdown) document.body.click();
    } catch (err) {
      setIsLoading(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  return isDropdown ? (
    <DropdownButton
      loading={isLoading}
      onClick={handleSubmit}
      data-keep-open={true}
      {...props}
    />
  ) : (
    <Button loading={isLoading} onClick={handleSubmit} {...props} />
  );
};

export default ApiDownloadButton;
